import { persistUiMode } from './theme';
import type { FuelType, LanguageCode, PriceMode, UiMode, UnitSystem } from '../types';

export const FUEL_PREFERENCES_KEY = 'beachlab.map.fuelPrefs.v1';
export const UNIT_PREFERENCES_KEY = 'beachlab.map.units.v1';
export const LANGUAGE_PREFERENCES_KEY = 'beachlab.map.language.v1';

export interface PreferenceStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): unknown;
}

export type PreferenceCookieWriter = (name: string, value: string) => void;

export function formatPreferenceCookie(name: string, value: string): string {
  return `${name}=${encodeURIComponent(value)};path=/map;max-age=31536000;samesite=lax`;
}

export function writePreferenceCookie(name: string, value: string): void {
  document.cookie = formatPreferenceCookie(name, value);
}

export function persistUnitPreference(
  units: UnitSystem,
  storage: PreferenceStorage = localStorage,
  writeCookie: PreferenceCookieWriter = writePreferenceCookie
): void {
  storage.setItem(UNIT_PREFERENCES_KEY, units);
  writeCookie('units', units);
}

export function persistLanguagePreference(
  language: LanguageCode,
  storage: PreferenceStorage = localStorage,
  writeCookie: PreferenceCookieWriter = writePreferenceCookie
): void {
  storage.setItem(LANGUAGE_PREFERENCES_KEY, language);
  writeCookie('language', language);
}

export function persistFuelPreferences(
  priceMode: PriceMode,
  fuelType: FuelType,
  storage: PreferenceStorage = localStorage,
  writeCookie: PreferenceCookieWriter = writePreferenceCookie
): void {
  storage.setItem(FUEL_PREFERENCES_KEY, JSON.stringify({ priceMode, fuelType }));
  writeCookie('fuelType', fuelType);
}

export function persistUiModePreference(
  mode: UiMode,
  storage: PreferenceStorage = localStorage
): void {
  persistUiMode(mode, storage);
}

export function selectAndActivateFuelType(
  fuelType: FuelType,
  setFuelType: (value: FuelType) => void,
  setFuelActive: (active: boolean) => void
): void {
  setFuelType(fuelType);
  setFuelActive(true);
}
